export default {"src":"/_next/static/image/src/onboarding/AccountFeatures/feeding-portion.9acf60670766951636bf21230274e147.svg","height":71,"width":69};